import { Route as ReactRoute, useRouteMatch } from 'react-router-dom';

import { useRoutePath } from '@app/components/Route/RoutePathProvider';

export default function Route(props: typeof ReactRoute.prototype.props) {
  const routePath = useRoutePath();

  // 현재 페이지의 route path를 넣어줍니다.
  const match = useRouteMatch({ ...props, exact: true });
  if (match?.path) {
    routePath.current = match.path;
  }

  return <ReactRoute {...props} />;
}
